"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMIN_NOT_FOUND = void 0;
const notFound_1 = __importDefault(require("../notFound"));
const _1 = require(".");
exports.ADMIN_NOT_FOUND = _1.ADMIN.child("/*", notFound_1.default);
